import React from "react";
import { Button } from "../../../Actions";
import { StepContent } from "../Components";
const Final: React.FC<{ onPlayComplete: any }> = ({ onPlayComplete }) => {
  return (
    <StepContent
      title="Imagine if they’d said the same about you…"
      description="Thanks for participating. You’ll receive your results and any invitations you’ve earned after you mint.">
      <Button
        analyticsProperty="Continue to mint"
        modifier="primary"
        onClick={onPlayComplete}>
        Continue To Mint
      </Button>
    </StepContent>
  );
};

export default Final;
